import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './common'
import '../scss/style.scss'

import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { hashHistory, Redirect, Route, Router } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'

import Bonifico from './components/buy/smart/Bonifico'
import BonificoReadyForDocs from './components/buy/smart/BonificoReadyForDocs'
import BuyWrapper from './components/buy/smart/BuyWrapper'
import Cart from './components/buy/smart/Cart'
import Checkout from './components/buy/smart/Checkout'
import Data from './components/buy/smart/Data'
import Documents from './components/buy/smart/Documents'
import DocumentsCompass from './components/buy/smart/DocumentsCompass'
import DocumentsFindomestic from './components/buy/smart/DocumentsFindomestic'
import FindomesticCertificatoInforcert from './components/buy/smart/FindomesticFirmaDigitale/FindomesticCertificatoInforcert'
import FindomesticContrattoFindomestic from './components/buy/smart/FindomesticFirmaDigitale/FindomesticContrattoFindomestic'
import FindomesticContrattoInfocert from './components/buy/smart/FindomesticFirmaDigitale/FindomesticContrattoInfocert'
import FindomesticCreaPin from './components/buy/smart/FindomesticFirmaDigitale/FindomesticCreaPin'
import FindomesticFirmaDigitale from './components/buy/smart/FindomesticFirmaDigitale/FindomesticFirmaDigitale'
import FindomesticServiziAssicurativi from './components/buy/smart/FindomesticFirmaDigitale/FindomesticServiziAssicurativi'
import ThanksFirma from './components/buy/smart/FindomesticFirmaDigitale/ThanksFirma'
import PreviewContratto from './components/buy/smart/PreviewContratto'
import Register from './components/buy/smart/Register'
import Restore from './components/buy/smart/Restore'
import RiepilogoFinanziamentoFindomestic from './components/buy/smart/RiepilogoFinanziamentoFindomestic'
import ServiziAggiuntiviUsato from './components/buy/smart/ServiziAggiuntiviUsato'
import Thanks from './components/buy/smart/Thanks'
import ThanksFindomestic from './components/buy/smart/ThanksFindomestic'
import SpinLoader from './components/dumb/SpinLoader'
import { store } from './store/Buy'
import { initSentry } from './utils/sentryUtils'

const history = syncHistoryWithStore(hashHistory, store)
const routes = (
  <Route component={BuyWrapper}>
    <Route component={Restore} path="/restore/:id_ordine/:id_token" />
    <Route component={Register} path="/register" />
    <Route component={Cart} path="/cart" />
    <Route component={ServiziAggiuntiviUsato} path="/servizi" />
    <Route component={Checkout} path="/checkout" />
    <Route component={Data} path="/dati" />
    <Route component={Data} path="/dati-finanziamento" />
    <Route
      component={RiepilogoFinanziamentoFindomestic}
      path="/riepilogo-finanziamento-findomestic"
    />
    <Route component={DocumentsCompass} path="/documents-compass" />
    <Route component={PreviewContratto} path="/preview-contratto" />
    <Route component={Bonifico} path="/bonifico" />
    <Route component={BonificoReadyForDocs} path="/bonifico-ready-for-docs" />
    <Route component={Documents} path="/documents" />
    <Route component={DocumentsFindomestic} path="/documents-findomestic" />
    <Route
      component={FindomesticCertificatoInforcert}
      path="/certificato-infocert"
    />
    <Route component={FindomesticCreaPin} path="/crea-pin" />
    <Route
      component={FindomesticContrattoInfocert}
      path="/contratto-infocert"
    />
    <Route
      component={FindomesticContrattoFindomestic}
      path="/contratto-findomestic"
    />
    <Route
      component={FindomesticServiziAssicurativi}
      path="/firma-servizi-assicurativi"
    />
    <Route component={FindomesticFirmaDigitale} path="/firma-digitale" />
    {/* Firma Findomestic V2 */}
    <Route
      component={() => <FindomesticCertificatoInforcert isV2 />}
      path="/v2/certificato-infocert"
    />
    <Route
      component={() => <FindomesticContrattoInfocert isV2 />}
      path="/v2/contratto-infocert"
    />
    <Route
      component={() => <FindomesticContrattoFindomestic isV2 />}
      path="/v2/contratto-findomestic"
    />
    <Route
      component={() => <FindomesticServiziAssicurativi isV2 />}
      path="/v2/firma-servizi-assicurativi"
    />
    <Route
      component={() => <FindomesticFirmaDigitale isV2 />}
      path="/v2/firma-digitale"
    />
    <Route component={Thanks} path="/thank-you" />
    <Route component={ThanksFindomestic} path="/thank-you-findomestic" />
    <Route component={ThanksFirma} path="/thank-you-firma" />
  </Route>
)

initSentry(routes)

render(<SpinLoader ui={{ fetching: true }} />, document.getElementById('buy'))

function renderApp() {
  render(
    <Provider store={store}>
      <Router history={history}>
        {routes}
        <Redirect from="/" to="register" />
      </Router>
    </Provider>,
    document.getElementById('buy')
  )
}

/**
 * TS-2097
 * la gestione seguente ci serve per attendere
 * che Google Optimize abbia terminato il suo caricamento
 * altrimenti potrebbe fare il redirect dopo che l'app
 * si e' renderizzata ed ha mangiato parametri su url
 * risultando in un redirect con dei parametri assenti
 */
window.renderApp = renderApp

if (window.optimizeIsReady) {
  renderApp()
} else {
  window.optimizeRenderAppTimeout = setTimeout(() => {
    // comunica ad optimize che e' arrivato in ritardo
    window.dataLayer.hide.end = null
    renderApp()
  }, 4000)
}
